module.exports = __webpack_public_path__ + "static/media/story-18.6f2f3e27.jpg";